<template>
  <v-card class="elevation-2" style="max-width: 100%;">
    <v-card-title class="pb-2 pt-2">
      <span style="font-size: 12px;" class="primary--text"
        >Products Weight (mt) Overview</span
      >
      <v-tooltip right>
        <v-icon small color="#ccc" slot="activator" class="pl-2">help</v-icon>
        <span
          >Display how many tons of products have been shipped month per month
          over a defined year. Only shipments with BL DATES are shown on the
          graph.</span
        >
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn small icon flat @click="previousYear">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <div>{{ selectedYear }}</div>
      <v-btn small icon flat @click="nextYear">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="py-0">
      <v-layout row wrap align-center v-if="!loading">
        <v-flex xs12>
          <apexchart
            type="area"
            width="100%"
            height="360px"
            :options="options"
            :series="series"
          />
        </v-flex>
      </v-layout>

      <!-- <v-layout row justify-center align-center v-if="!loading && !series.length" class="pa-4">
        <span class="error--text">
          <v-icon class="error--text" small>warning</v-icon>No expenses found
        </span>
      </v-layout>-->

      <div class="pa-4 text-xs-center" v-if="loading">
        <looping-rhombuses-spinner
          style="margin: auto;"
          class="text-xs-center"
          :animation-duration="1000"
          :size="74"
          color="#1976d2"
        />
        <h3 class="title font-weight-light my-2">Loading Chart...</h3>
        <span class="caption grey--text">Please wait</span>
      </div>
    </v-card-text>
    <!-- <json-viewer :value="series"></json-viewer>

    <json-viewer :value="parsedDataByDate"></json-viewer>-->
  </v-card>
</template>

<script>
import apexchart from "vue-apexcharts";
import { mapGetters } from "vuex";
import date from "../../../mixins/date";
import TOTAL_MT_WEIGHTS_QUERY from "../../../graphql/accounting/total_mt_weights_query.gql";
import JsonViewer from "vue-json-viewer";
import { LoopingRhombusesSpinner } from "epic-spinners";

export default {
  name: "mtWeightGraph",

  components: { apexchart, JsonViewer, LoopingRhombusesSpinner },
  mixins: [date],
  data() {
    return {
      loading: true,
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
      fetchedData: [],
      options: {
        annotations: {
          // xaxis: [{
          //   x: "Apr 2020",
          //   borderColor: '#999',
          //   yAxisIndex: 0,
          //   label: {
          //     show: true,
          //     text: 'Rally',
          //     style: {
          //       color: "#fff",
          //       background: '#775DD0'
          //     }
          //   }
          // }]
        },
        yaxis: {
          showAlways: true,
          showForNullSeries: true,
          labels: {
            formatter: this.formatterMt,
          },
        },
        chart: {
          type: "area",
          height: 350,
          stacked: false,
        },
        // colors: ["#008FFB", "#00E396", "#CED4DC"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          },
        },

        xaxis: {
          categories: [],
          showAlways: true,
          showForNullSeries: true,
        },
      },
    };
  },
  computed: {
    ...mapGetters("commonStore", ["accountTypes"]),

    series() {
      //retrieve all categories
      var categories = [];
      Object.entries(this.parsedDataByDate).forEach(([k, v]) => {
        Object.entries(v).forEach(([cat, tot]) => {
          categories.push(cat);
        });
      });

      var retArr = [];

      [...new Set(categories)].forEach((category) => {
        retArr.push({ name: category, data: [] });
      });

      var dateList = Object.keys(this.parsedDataByDate);

      var sortedDates = dateList.sort(function (a, b) {
        return Date.parse(a, "MMM YYYY") - Date.parse(b, "MMM YYYY");
      });

      retArr.forEach((serie) => {
        sortedDates.forEach((sd) => {
          if (serie.name in this.parsedDataByDate[sd]) {
            serie.data.push(this.parsedDataByDate[sd][serie.name]);
          } else {
            serie.data.push(0);
          }
        });
      });

      //Create Categories with Total for each month
      this.options.xaxis.categories = sortedDates;

      return retArr;
    },
    parsedDataByDate() {
      const dateF = this.friendlyDateWithoutDay;
      var productCategories = {};

      // Init all months of selected year
      var i;
      for (i = 0; i < 12; i++) {
        productCategories[dateF(new Date(this.selectedYear, i))] = {};
      }

      //create date fields
      this.fetchedData.forEach((fd) => {
        fd.shipping_unit_products.forEach((sup) => {
          // Add date key if not exist

          if (dateF(fd.expedition.bl_date) in productCategories) {
            //Add product category if not already present
            if (
              !(
                sup.product_trade.product.product_category.name in
                productCategories[dateF(fd.expedition.bl_date)]
              )
            ) {
              productCategories[dateF(fd.expedition.bl_date)][
                sup.product_trade.product.product_category.name
              ] = 0;
            } else {
              //Otherwise add weight of the product
              productCategories[dateF(fd.expedition.bl_date)][
                sup.product_trade.product.product_category.name
              ] += sup.loaded_net_weight_mt;

              //Round value
              productCategories[dateF(fd.expedition.bl_date)][
                sup.product_trade.product.product_category.name
              ] =
                Math.round(
                  productCategories[dateF(fd.expedition.bl_date)][
                    sup.product_trade.product.product_category.name
                  ] * 10000
                ) / 10000;
            }
          }
        });
      });

      return productCategories;
    },
  },
  methods: {
    formatterMt(val) {
      return val + " (mt)";
    },
    fetchData() {
      this.loading = true;
      this.sendQuery(TOTAL_MT_WEIGHTS_QUERY, {
        // filter: this.monthsFilter() + " && operation_type == debit"
      })
        .then((data) => {
          this.fetchedData = data.shipping_units.filter(
            (su) => su.expedition.bl_date
          );

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    nextYear() {
      this.selectedYear += 1;
    },
    previousYear() {
      this.selectedYear -= 1;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
